import React from "react";

import { Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(theme => ({
  arrow: {
    borderRight: "24px solid transparent",
    borderTop: `24px solid ${theme.palette.grey["400"]}`,
    bottom: -25,
    position: "absolute",
    left: 15,
    "&:after": {
      content: "''",
      borderRight: "21px solid transparent",
      borderTop: `21px solid ${theme.palette.background.paper}`,
      bottom: 5,
      position: "absolute",
      left: 2
    }
  }
}));

const SpeechBubble = ({ children }) => {
  const {classes} = useStyles();
  return (
    <Box
      border="2px solid"
      borderRadius="16px"
      borderColor="grey.400"
      position="relative"
      bgcolor="background.paper"
      pl={2}
      pr={2}
      pb={1}
      pt={1}
      minHeight={40}
      mb={3}
    >
      {children}
      <div className={classes.arrow}></div>
    </Box>
  );
};

export default SpeechBubble;
